import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { WidgetContext } from '../../../components/App';
import * as styles from './Header.module.css';
export const Header = ({ redirectState, redirectText, className = '', classNameRedirect = '', children, }) => {
    const { redirectToState } = useContext(WidgetContext);
    return (_jsxs("div", { className: `${styles.headerContainer} ${className}`, children: [children, redirectState && (_jsx("div", { className: `${styles.redirect} ${classNameRedirect}`, children: _jsx("span", { onClick: () => redirectToState(redirectState), children: redirectText }) }))] }));
};
